<template>
  <helmi-group-dashboard-card
    :initializing="loadingCharts"
    class="helmi-group-dashboard-cumulative-return"
    title="Kuukausittainen tuotto"
    subtitle="(Brutto)"
    fullscreen
    use-theme
  >
    <h-line-echart
      :title="echartsData.title"
      :labels="echartsData.labels"
      :series="echartsData.series"
    />
  </helmi-group-dashboard-card>
</template>

<script>
import { mapState } from 'vuex';

const echartsData = {
  title: 'Kumulatiivinen tuotto',
  labels: [
    'Tammi',
    'Helmi',
    'Maalis',
    'Huhti',
    'Touko',
    'Kesä',
    'Heinä',
    'Elo',
    'Syys',
    'Loka',
    'Marras',
    'Joulu',
  ],
  series: [],
};

export default {
  name: 'GroupDashboardCumulativeReturn',

  components: {
    'h-line-echart': () => import('@/components/charts/LineChartEcharts'),
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  data: () => ({
    chartData: {
      datasets: [],
    },
    echartsData: {
      title: '',
      labels: [],
      series: [],
    },
    context: null,
    fullscreen: false,
    loaded: false,
  }),

  computed: {
    ...mapState({
      selectedGroupCompanies: 'selectedGroupCompanies',
      chartYear: 'chartYear',
      monthlyProfit: 'monthlyProfit',
      loadingCharts: 'loadingCharts',
    }),
  },

  watch: {
    monthlyProfit: {
      async handler() {
        this.fillCharts();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async fillCharts() {
      this.echartsData = {
        ...echartsData,
        series: this.monthlyProfit.map(result => ({
          name: result.name,
          data: result.data.map(item => item.profit),
          type: 'line',
        })),
      };
    },
  },
};
</script>
